export const useMobileUserPop = () => {
  const opener = useState<null | (() => void)>('mobile-user-pop-opener', () => null);
  const openerOwnerId = useState<string | null>('mobile-user-pop-opener-owner-id', () => null);
  const ownerSeed = useState('mobile-user-pop-opener-owner-seed', () => 0);

  const createMobileUserPopOwner = () => {
    ownerSeed.value += 1;
    const fallbackId = `mobile-user-pop-${Date.now()}-${ownerSeed.value}`;

    if (
      import.meta.client &&
      typeof crypto !== 'undefined' &&
      typeof crypto.randomUUID === 'function'
    ) {
      return crypto.randomUUID();
    }

    return fallbackId;
  };

  const registerMobileUserPop = (ownerId: string, nextOpener: null | (() => void)) => {
    if (nextOpener) {
      openerOwnerId.value = ownerId;
      opener.value = nextOpener;
      return;
    }

    if (openerOwnerId.value === ownerId) {
      openerOwnerId.value = null;
      opener.value = null;
    }
  };

  const openMobileUserPop = () => {
    opener.value?.();
  };

  return {
    createMobileUserPopOwner,
    mobileUserPopOpener: opener,
    registerMobileUserPop,
    openMobileUserPop,
  };
};
